export default __webpack_public_path__ + "static/media/ABW-Portrait-Sabine-klein.096f0a85.jpg";